module.exports = __webpack_public_path__ + "static/media/S-task01_nodeLink.9aabba82.png";